/// <reference path="../supplieroutstandingmodal/index.js" />
import Revenue_CategoryWise from '../../../../assets/images/Revenue(CategoryWise).png';
import { useEffect, useState } from 'react';
import Chart from 'react-google-charts';
import { toast } from 'react-toastify';
import { managementFinanceAPI } from '../../../../api/managementFinanceAPI';
import Calendar from '../../../datepicker/calendar';
import AllPcode from '../../../allPcode';
import usePcode from '../../../../common/hooks/usePcode';

const options = {
    colors: ['#0000cc', '#990000'],
    title: "Revenue (Job Type Wise)",
    fontSize: 15,
    chartArea: {
        width: "50%",
    },
    width: "100%",
    height: 400,
    isStacked: true,
    hAxis: {
        title: "Job Type Name",
        titleTextStyle: {
            color: '#333',
            bold: true,
            fontSize: 15
        },
        textStyle: {
            color: '#333',
            fontSize: 9,
            bold: true,
        },
        slantedText: true,
        slantedTextAngle: 25
    },
    vAxis: {
        title: "Net Total (LKR)",
        titleTextStyle: {
            color: '#333',
            bold: true,
            fontSize: 15
        },
        textStyle: {
            color: '#333'
        },
        baselineColor: "#000000"
    },
    series: {
        0: {
            curveType: 'function'
        },
        1: {
            curveType: 'function'
        }
    }
};

export default function Revenue_CategoryWiseModal() {
    const [monthYr, setMonthYr] = useState(new Date());
    const [revenueData, setRevenueData] = useState([]);
    const [showChart, setShowChart] = useState(false);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);



    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("CaseReceived");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    useEffect(() => {
        handlRevenueDetailsCategoryWise(selectedPcode, monthYr);
    }, [selectedPcode, monthYr]);

    const handlRevenueDetailsCategoryWise = (selectedPcode, monthYr) => {
        if (!monthYr) { toast.warn("Please select month and year"); return; }
        const month = monthYr.getMonth() + 1;
        const year = monthYr.getFullYear();
        managementFinanceAPI.getRevnueDetails(month, year, selectedPcode).then((data) => {
            setRevenueData(data);
        }).catch((err) => {
            toast.error(err.message);
        });
    }

    const chartData = [['Job Type Name', 'Net Total']];
    revenueData.forEach(item => {
        chartData.push([item.jobTypeName, parseFloat(item.netTotal)])
    });

    const handleDatePicker = (date) => {
        setMonthYr(date);
    }

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#CaseReceived">
                <img src={Revenue_CategoryWise} className="card-img-top rounded rounded-5" alt="CaseReceived" />
            </a>
            <div className="modal fade" id="CaseReceived" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Revenue (Job Type Wise)</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-8 col-xl-8 col-xxl-8">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
                                    <div className="input-group input-group-sm">
                                        <Calendar onChange={handleDatePicker} />
                                    </div>
                                </div>
                                {showChart ? (
                                    revenueData.length > 0 ? (
                                        <Chart
                                            chartType="ColumnChart"
                                            style={{ marginTop: "20px", marginBottom: "20px", width: "100%", height: "400px" }}
                                            data={chartData}
                                            options={options}
                                        />
                                    ) : (
                                        <h3>No Data Available</h3>
                                    )
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}